import { SubscriberDetailModel } from './subscriber.detail.model';

export class PagedSubscriberDetailModel {
    currentPage: number;
    totalPages: number;
    pageSize: number;
    totalCount: number;
    items: SubscriberDetailModel[] = [];
}
